<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#domain-list" @click="activeComponent='tabDomainList'"><i class="fa fa-newspaper-o"></i> Domain List ({{ registrar.domainCount | domainCount }})</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row" v-if="activeComponent">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import DomainList from './Tabs/DomainList'
export default {
  data () {
    return {
      activeComponent: 'tabDomainList'
    }
  },
  computed: {
    registrar: ({$route, $store}) => $store.state.registrarList.find(u => u.id === $route.params.id) || {}
  },
  filters: {
    domainCount: count => count || 0
  },
  components: {
    tabDomainList: DomainList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrar/Content.vue